import { TransactionApi } from '@/api/transaction'

const state = () => ({
    transactions: [],
    transactionsPagination: {
        perPage: 10,
        page: 1,
        search: '',
        filter: '',
        start: '',
        end: '',
        from: 1,
        is_have_transaction: ''
    },
    transaction: null,
    transactionSummary: {},
    isLoadingTransaction: false,
    isSuccessTransaction: true,
    messageTransaction: '',
    isLoadingTransactionReport: false,
    userTransaction: [],
    isLoadingUserTransaction: false,
    transactionUserDetail: {
        perPage: 10,
        first: 0,
    }
})

const getters = {
    transactionsList: state => state.transactions,
    transactionsPagination: state => state.transactionsPagination,
    transaction: state => state.transaction,
    transactionSummary: state => state.transactionSummary,
    isLoadingTransaction: state => state.isLoadingTransaction,
    isSuccessTransaction: state => state.isSuccessTransaction,
    messageTransaction: state => state.messageTransaction,
    isLoadingTransactionReport: state => state.isLoadingTransaction,
    userTransaction: state => state.userTransaction,
    isLoadingUserTransaction: state => state.isLoadingUserTransaction,
    transactionUserDetail: state => state.transactionUserDetail
}

const actions = {
    async fetchSummaryTransaction({ commit }) {
        await TransactionApi.getSummaryTransaction()
            .then(res => {
                // console.log(res.data.data)
                if (res.data.success) {
                    commit('setTransactionSummary', res.data.data)
                    commit('setSuccessTransaction', true)
                } else {
                    commit('setSuccessTransaction', false)
                    commit('setMessageTransaction', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessTransaction', false)
                commit('setMessageTransaction', error.errors[0].message)
            })
    },
    async fetchAllTransactions({ commit }, query) {
        let page = 1
        let perPage = 10
        let search = query.search
        let filter = query.filter
        let start = query.start
        let end = query.end
        let isHaveTransaction = query.isHaveTransaction
        let payment_id = query.payment_id
        let classroom = query.classroom
        if (query !== null) {
            page = query.page
            perPage = query.perPage
        }
        commit('setIsLoadingTransaction', true)
        await TransactionApi.getAllFilter(perPage, page, search, filter, start, end, isHaveTransaction, payment_id, classroom)
            .then(response => {
                commit('setTransactions', response.data.data)
                const pagination = {
                    total: response.data.pages.total,
                    perPage: response.data.pages.per_page,
                    page: response.data.pages.current_page,
                    search: search,
                    filter: filter,
                    start: start,
                    end: end,
                    payment_id: payment_id,
                    classroom: classroom,
                    from: response.data.pages.from,
                    isHaveTransaction
                }
                commit('setTransactionsPagination', pagination)
                commit('setIsLoadingTransaction', false)
                commit('setSuccessTransaction', true)
            })
            .catch(error => {
                // console.log(error)
                commit('setIsLoadingTransaction', false)
                commit('setSuccessTransaction', false)
                commit('setMessageTransaction', error)
            })
    },
    async fetchDetailTransaction({ commit }, id) {
        // console.log(id)
        await TransactionApi.detail(id)
            .then(res => {
                commit('setTransactionDetail', res.data.data)
                commit('setSuccessTransaction', true)
            })
            .catch(error => {
                commit('setSuccessTransaction', true)
                commit('setMessageTransaction', error)
            })
    },
    async verifyTransaction({ commit }, id) {
        await TransactionApi.verify(id)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessTransaction', true)
                    commit('setMessageTransaction', 'Verifikasi Transaksi')
                } else {
                    commit('setSuccessTransaction', false)
                    commit('setMessageTransaction', 'Terjadi Kesalahan Verifikasi')
                }
            })
            .catch(error => {
                commit('setSuccessTransaction', false)
                commit('setMessageTransaction', error)
            })
    },
    async rejectTransaction({ commit }, data) {
        const id = data.id
        const payload = data.payload
        await TransactionApi.reject(id, payload)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessTransaction', true)
                    commit('setMessageTransaction', 'Reject Transaksi')
                } else {
                    commit('setSuccessTransaction', false)
                    commit('setMessageTransaction', 'Terjadi Kesalahan Reject')
                }
            })
            .catch(error => {
                commit('setSuccessTransaction', false)
                commit('setMessageTransaction', error)
            })
    },
    async exportTransactionReport({ commit }, payload) {
        commit('setIsLoadingTransactionReport', true)
        await TransactionApi.exportTransaction(
                payload.perPage,
                payload.start,
                payload.end,
            )
            .then(response => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.ms-excel',
                })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.setAttribute(
                    'download',
                    `Laporan Transaksi ${payload.start} - ${payload.end}.xlsx`
                )
                link.click()
                URL.revokeObjectURL(link.href)
                commit('setIsLoadingTransactionReport', false)
                commit('setMessageTransaction', 'Download Report Transaksi')
                commit('setSuccessTransaction', true)
            })
            .catch(error => {
                commit('setSuccessTransaction', false)
                commit('setMessageTransaction', error)
                commit('setIsLoadingTransactionReport', false)
            })
    },
    async historyUserTransaction({ commit }, uuid) {
        commit('setIsLoadingUserTransaction', true)
        await TransactionApi.getUserTransaction(uuid)
            .then(res => {
                commit('setIsLoadingUserTransaction', false)
                commit('setUserTransaction', res.data.data)
            })
            .catch(error => {
                console.log(error)
                commit('setIsLoadingUserTransaction', false)
            })
    },
    saveTransactionUserDetail({ commit }, pages) {
        commit('setTransactionUserDetail', pages)
    },
}

const mutations = {
    setTransactions: (state, transactions) => {
        state.transactions = transactions
    },

    setTransactionsPagination: (state, transactionsPagination) => {
        state.transactionsPagination = transactionsPagination
    },

    setTransactionDetail: (state, detail) => {
        state.transaction = detail
    },

    setTransactionSummary: (state, summary) => {
        state.transactionSummary = summary
    },

    setIsLoadingTransaction: (state, isLoading) => {
        state.isLoadingTransaction = isLoading
    },

    setSuccessTransaction: (state, isSuccess) => {
        state.isSuccessTransaction = isSuccess
    },

    setMessageTransaction: (state, message) => {
        state.messageTransaction = message
    },

    setIsLoadingTransactionReport: (state, isLoading) => {
        state.isLoadingTransactionReport = isLoading
    },

    setUserTransaction: (state, history) => {
        state.userTransaction = history
    },

    setIsLoadingUserTransaction: (state, loading) => {
        state.isLoadingUserTransaction = loading
    },

    setTransactionUserDetail: (state, pages) => {
        state.transactionUserDetail = pages
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}